module.exports = __webpack_public_path__ + "static/fontawesome-webfont-c8ddf1e5e5bf3682bc7bebf30f394148.woff";